import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ParameterUnitService } from './parameter-unit.service';
import { Units, UnitSymbols } from '../enums/units.enum';

const UG_PER_M3_TO_MG_PER_M3 = 0.001;
const MG_PER_M3_TO_UG_PER_M3 = 1000;
const CM2_TO_FT2_CONVERSION = 929.0304;
const PPB_TO_PPM = 1000;
const HOURS_TO_SECONDS = 3600;
const MINUTES_TO_SECONDS = 60;
const CM_TO_FT = 30.48;
const SQFT_TO_SQCM = 929.0304;

@Injectable({
    providedIn: 'root'
})
export class ValueConversionService extends ParameterUnitService {
    constructor(protected authService: AuthService) {
        super(authService)
    }

    getParameterValueAsPerAgentUnit(value, unit: Units) {
        if (unit === Units.MgPerM3) {
            value = this.convertUgPerM3ToMgPerM3(value);
        } else if (unit === Units.Ppm) {
            value = this.convertPpbToPpm(value);
        } else if (unit === Units.UgPerCm2) {
            value = this.convertUgPerFt2ToUgPerCm2(value);
        }
        return value;
    }

    getParameterUnitSymbol(unit: Units) {
        return UnitSymbols[unit];
    }

    convertAgentUnitValueToBase(value, unit: Units) {
        if (unit === Units.MgPerM3) {
            value = this.convertMgPerM3ToUgPerM3(value);
        } else if (unit === Units.Ppm) {
            value = this.convertPpmToPpb(value);
        } else if (unit === Units.UgPerCm2) {
            value = this.convertUgPerCm2ToUgPerFt2(value);
        }
        return value;
    }


    convertUgPerM3ToMgPerM3(value) {
        return value * UG_PER_M3_TO_MG_PER_M3;
    }

    convertMgPerM3ToUgPerM3(value) {
        return value * MG_PER_M3_TO_UG_PER_M3;
    }

    convertUgPerFt2ToUgPerCm2(value: number): number {
        return value / CM2_TO_FT2_CONVERSION;
    }

    convertUgPerCm2ToUgPerFt2(value: number): number {
        return value * CM2_TO_FT2_CONVERSION;
    }

    convertPpbToPpm(value) {
        return value / PPB_TO_PPM;
    }

    convertPpmToPpb(value) {
        return value * PPB_TO_PPM;
    }

    convertHoursToSeconds(value) {
        return value * HOURS_TO_SECONDS;
    }

    convertMinutesToSeconds(value) {
        return value * MINUTES_TO_SECONDS;
    }

    convertSecondsToHours(value) {
        return value / HOURS_TO_SECONDS;
    }

    convertSecondsToMinutes(value) {
        return value / MINUTES_TO_SECONDS;
    }

    convertCmToFt(value: number) {
        return value / CM_TO_FT;
    }

    convertFtToCm(value: number) {
        return value * CM_TO_FT;
    }

    convertSqFtToSqCm(value: number) {
        return value * SQFT_TO_SQCM;
    }

    convertSqCmToSqFt(value: number) {
        return value / SQFT_TO_SQCM;
    }

    getAveragingPeriod(averagingPeriod: number): string {
        if (averagingPeriod < 60 * 60) {
            const minutes = this.convertSecondsToMinutes(averagingPeriod);
            const unit = minutes === 1 ? 'min' : 'mins';
            return `${minutes} ${unit}`;
        } else {
            const hours = this.convertSecondsToHours(averagingPeriod);
            const unit = hours === 1 ? 'hour' : 'hours';
            return `${hours} ${unit}`;
        }
    }
}
